<template>
  <div
    ref="animationContainer"
    :style="{
      width: '90%',
      margin: 'auto',
    }"
    fetchpriority="high"
  ></div>
</template>
<!-- gtOneZeroTwoFour ? '400px' : '300px' -->

<script lang="ts" setup>
import { useQuasar } from 'quasar';
import { useLottie } from '@/composables/useLottie';
import animationData from '../../assets/images/animate/animated_hero.json'
import { computed } from 'vue';

const q = useQuasar();
const { animationContainer } = useLottie(animationData);
const gtOneZeroTwoFour = computed(() => q.screen.width > 1024)
</script>

<style lang="scss" scoped>
div {
  background-color: #ffffff;
  display: block;
}
</style>
